import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BoxV2, TextAreaWithChips } from '@labrav/react-components'
import React from 'react'

import { faListCheck } from '@fortawesome/pro-regular-svg-icons'
import { Typography } from '@mui/material'
import { FormikProps, useFormikContext } from 'formik'
import { FlyoutProductSections } from '../../../types/addEditProduct'
import { useStyles } from './FlyOutProductAllowlistedAWSAccounts.styles'
import { RequirementLink } from '../../../types/RequirementLink'
import { FormLockedType } from '../../../types/FormLockedType'
import { FlyoutProductDetailsAllowlistedAccountsFaqs } from './FlyoutProductDetailsAllowlistedAccountsFaqs'

type FlyOutProductAllowlistedAWSAccountsProps = {
  detailView?: boolean
}

export const FlyOutProductAllowlistedAWSAccounts: React.FC<
  RequirementLink & FormLockedType & FlyOutProductAllowlistedAWSAccountsProps
> = ({ isFormLocked, detailView }) => {
  const { classes } = useStyles()
  const { values, errors, touched, handleBlur, setFieldValue } =
    useFormikContext() as FormikProps<FlyoutProductSections>

  const generalInformation = values.generalInformation
  const generalInformationErrors = errors.generalInformation
  const generalInformationTouched = touched.generalInformation

  const selectedTags = generalInformation?.allowedAccounts
    ? generalInformation?.allowedAccounts.split(',')
    : []

  const handleTagsChange = (newTags: string) => {
    if (newTags && !selectedTags?.includes(newTags)) {
      const updatedTags = [...selectedTags, newTags]
      setFieldValue('generalInformation.allowedAccounts', updatedTags.join(','))
    }
  }

  const handleDelete = (value: string) => {
    const filteredOptions = selectedTags.filter(option => option !== value)
    setFieldValue(
      'generalInformation.allowedAccounts',
      filteredOptions.join(',')
    )
  }

  return (
    <BoxV2
      heading={'Configure allowlist'}
      headingIcon={
        <FontAwesomeIcon
          icon={faListCheck}
          style={{ width: '18px', height: '14px' }}
        />
      }
      secondaryActions={<FlyoutProductDetailsAllowlistedAccountsFaqs />}
    >
      <>
        <div
          className={classes.sectionContainer}
          data-testid="allowlisted-AWS-accounts"
        >
          <div className={classes.textContainer}>
            <div className={classes.sectionHeadingContainer}>
              {' '}
              <Typography className={classes.sectionHeading}>
                Allowlisted AWS accounts
              </Typography>
              <Typography className={classes.sectionText}>Optional</Typography>
            </div>
            <Typography className={classes.sectionText}>
              Specify which accounts you want to add to your product’s allowlist
              by entering the AWS account IDs in the field below.
            </Typography>
          </div>
          <div className={classes.textFieldWidth}>
            <TextAreaWithChips
              id={'generalInformation.allowedAccounts'}
              label={'Enter comma-separated accounts IDs'}
              onBlur={handleBlur}
              onChange={handleTagsChange}
              handleDelete={handleDelete}
              selectedValues={selectedTags}
              type="number"
              error={
                !!(
                  generalInformationErrors?.allowedAccounts &&
                  generalInformationTouched?.allowedAccounts
                )
              }
              helperText={
                (generalInformationTouched?.allowedAccounts &&
                  generalInformationErrors?.allowedAccounts) ||
                ''
              }
              showSpinner={false}
              disabled={isFormLocked || detailView}
              viewOnly={detailView}
            />
          </div>
        </div>
      </>
    </BoxV2>
  )
}
